export enum LoanType {
  FreezeLoans = 0, // Indefrysningslån
  PensionerLoans = 1, // Pensionistlån
  AdditionalLoans = 2, // Tillægslån
}
